import type { EmbeddedPromptOut } from '@repo/api-codegen';
import { IconButton } from '@repo/foundations';
import { useAIFeedback, type IEmbeddedPrompt } from '../../../api';
import { SentimentType } from '../AIFeedbackModal/constants';

export function NegativeFeedbackButton({
	message,
}: {
	message: IEmbeddedPrompt | EmbeddedPromptOut;
}) {
	const { showNegativeFeedbackModal } = useAIFeedback();

	if (message.user_feedback_raw?.sentiment === SentimentType.Negative) {
		return (
			<IconButton
				iconName="thumbDownFilled"
				variant="tertiary"
				tooltip="Negative feedback for this prompt already submitted"
			/>
		);
	}

	return (
		<IconButton
			iconName="thumbDown"
			variant="tertiary"
			onClick={() => showNegativeFeedbackModal(message.id)}
			tooltip="Unhelpful"
		/>
	);
}
